export const styles = (theme: any) => {
    return {
        contentAreaStyles: {
            padding: "0 20px",
            minHeight: "100vh",
            marginBottom: "20px"
        }
    }
}